import React from 'react';
import { Box, Text } from '@rsos/components/capstone/base';

const AlertTypesEmptyState = () => {
  return (
    <Box height="100%" px={50} align="center" justify="center">
      <Text color="secondaryLink" size="normal">
        Please select an agency you would like to pair with
      </Text>
    </Box>
  );
};

export default AlertTypesEmptyState;
